module.exports = __webpack_public_path__ + "static/img/7.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/7.png
// module id = 2Zqe
// module chunks = 0